export const trackPixelEvent = (
  event: string,
  data?: Record<string, unknown>,
  extraData?: Record<string, unknown>
) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', event, data, extraData)
  }
}
